import text from "./text"

const paragraph = {
  600: {
    ...text["600"],
  },
  500: {
    ...text["500"],
  },
  400: {
    ...text["400"],
  },
  300: {
    ...text["300"],
  },
}

export default paragraph
